import type {ChannelToggle} from '@api/notifications';
import {ChannelToggleGroup} from './ChannelToggleGroup';

/** Приоритет очереди: каналы выбираются напрямую, без дублирующего выключателя. */
export const SectionRow = ({
  label,
  settings,
  availableChannels,
  disabled,
  onChange,
}: {
  label: string;
  settings: ChannelToggle;
  availableChannels: ChannelToggle;
  disabled?: boolean;
  onChange: (value: ChannelToggle) => void;
}) => (
  <div className='flex min-w-0 flex-wrap items-center justify-between gap-x-4 gap-y-2 py-2'>
    <span className='min-w-0 text-xs text-[var(--color-muted-foreground)]'>
      {label}
    </span>
    <ChannelToggleGroup
      label={label}
      value={settings}
      connected={availableChannels}
      disabled={disabled}
      onChange={onChange}
    />
  </div>
);
